<template>
  <div id="pre_start_video">
    <h1>we have to see your room before start</h1>
    <h4>press "start recording" then turn your webcam and show the room.</h4>
    <h3>
      if you experience any difficaulties (like webcam power off or...) fix the issue, refresh the page and
      follow this process again
    </h3>
    <button v-if="!isRecording" @click="startRecording">
      <span v-if="preStartVideoFulfilled">Record Again</span>
      <span v-else>Start Recording</span>
    </button>
    <button v-if="isRecording" @click="stopRecording">Stop Recording</button>

    <button v-if="preStartVideoFulfilled && !isRecording" @click="preStartVideoConfirmed">Approve & Start exam</button>
    <button v-if="!isRecording" @click="showDashboard">Cancel</button>

    <div>{{ countDownTimer }}</div>

    <div>
      <video style="width: 50%;" id="pre_start_video_element"></video>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { getWebcamStream, getVideoRecorder } from '../../plugins/webcam'

export default {
  data() {
    return {
      mediaRecorder: null,
      isRecording: false,
      countDownTimer: 20 // seconds
    }
  },

  computed: {
    ...mapGetters('exam', ['exam_details']),
    ...mapGetters('invigilate', ['preStartVideoFulfilled']),
    ...mapState(['user_id', 'exam_id'])
  },

  methods: {
    async startRecording() {
      this.isRecording = true
      this.countDown()
      this.$store.dispatch('invigilate/removePreStartVideo')
      let { stream } = await getWebcamStream({ quality: 'high' })
      let chunks = []

      // play video
      let video = document.getElementById('pre_start_video_element')
      video.srcObject = stream
      await video.play()

      // start recording
      this.mediaRecorder = getVideoRecorder(stream)
      this.mediaRecorder.ondataavailable = (e) => {
        chunks.push(e.data)
      }

      this.mediaRecorder.onerror = function(e) {
        console.log('mediaRecorder.onerror: ' + e)
      }
      this.mediaRecorder.onwarning = function(e) {
        console.log('this.mediaRecorder.onwarning: ' + e)
      }

      this.mediaRecorder.onstop = () => {
        let blob = new Blob(chunks, { type: 'video/webm' })
        this.$store.dispatch('invigilate/savePreStartVideo', blob)
        this.mediaRecorder = null
      }

      this.mediaRecorder.start()
    },

    stopRecording() {
      this.isRecording = false
      this.countDownTimer = 20
      if (this.mediaRecorder) {
        this.mediaRecorder.stop()
      }
    },

    preStartVideoConfirmed() {
      this.$store.dispatch('exam/preStartCheckLevelOne')
    },

    showDashboard() {
      this.stopRecording()
      this.$store.dispatch('invigilate/removePreStartVideo')
      this.$store.dispatch('initializeApp')
    },

    countDown() {
      this.countDownTimer = this.countDownTimer - 1
      if (this.countDownTimer > 1 && this.isRecording) {
        setTimeout(() => {
          this.countDown()
        }, 1000)
      } else {
        this.stopRecording()
      }
    }
  }
}
</script>
